import { makeUniqueId, remove } from 'utilities/data';
import { getRemoteIFrameMessage } from 'utilities/communication';
import { BaseDistinctIdProvider } from './base_distinct_id_provider';

export const LOADING_STATES = {
    UNLOADED: 'unloaded',
    LOADING: 'loading',
    LOADED: 'loaded',
    TIMEDOUT: 'timedout'
};

export class CrossDomainCookieDistinctIdProvider extends BaseDistinctIdProvider {
    init() {
        this.state = LOADING_STATES.UNLOADED;
        this.sessionActivated = false;
    }

    getIdInfo() {
        return new Promise((resolve, reject) => {
            if (this.state === LOADING_STATES.LOADED) {
                resolve(this.userInfo);
            } else if (this.state === LOADING_STATES.TIMEDOUT) {
                reject();
            }

            return (
                this.load()
                    .then(resolve)
                    .catch(reject)
            );
        });
    }

    load() {
        const src = 'distinctid.html',
            attrs = {
                id: makeUniqueId()
            },
            timeout_ms = 2000;

        this.state = LOADING_STATES.LOADING;

        return (
            getRemoteIFrameMessage(src, attrs, timeout_ms)
                .then(({ data: userInfo, messageReceiver }) => {
                    this.state = LOADING_STATES.LOADED;
                    this.messageReceiver = messageReceiver;
                    this.userInfo = userInfo;

                    return userInfo;
                })
                .catch(() => {
                    this.state = LOADING_STATES.TIMEDOUT;
                    throw LOADING_STATES.TIMEDOUT; // pass promise rejection down the chain
                })
        );
    }

    setActivatedUser() {
        if (this.sessionActivated) {
            return;
        } else {
            this.sessionActivated = true;
        }

        this.userInfo.iu++;

        if (this.state === LOADING_STATES.LOADED && this.messageReceiver) {
            this.messageReceiver.send({
                source: 'hapyak-distinct-id',
                command: 'set_iu'
            });
        }
    }
}